import "@/util/extends/toFirstUpperCase";
import router from "@/router/index";
import { api } from "@/api/index";
import axios from "axios";

//通用模块状态控制
const authModule = {
  state: {
    user: "", //用户信息
    token: "",
    /**
     * 获取用户所有菜单
     * @Author BillionChen
     * @param  {[type]}    state [description]
     * @return {[type]}          [description]
     */
  },

  //激发事件改变state
  mutations: {
    //设置菜单导航
    SET_MENU: (state, menuTree) => {
      state.menuTree = menuTree;
    },
    //设置用户信息
    SET_USER: (state, user) => {
      state.user = user;
    },
    //设置TOKEN
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    //退出登录/登录失效
    AUTH_LOGOUT(state) {
      api.user.setUserLogout().then((res) => {
        if (res.status) {
          window.location = res.data;
        } else {
          console.log("退出登录", res);
        }
        resolve();
      });
    },
  },

  //异步操作拿远程数据,然后提交事件
  actions: {
    //检查登录操作获取用户信息
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.user.getCurrent().then((res) => {
          // console.log("获取用户信息",JSON.parse(JSON.stringify(res)));
          if (res.status) {
            commit("SET_USER", res.data);
          } else {
            commit("SET_USER", {});
            console.log("用户信息获取失败:", res);
            // commit('SET_USER', res.data);
          }
          resolve(res);
        });
      });
    },
  },
};

export default authModule;



// WEBPACK FOOTER //
// ./src/store/modules/auth.js